import { Col, Progress, Row, Tooltip } from 'antd';
import { Rule } from 'antd/lib/form';
import React, { ReactElement } from 'react';
import { getDateWithTime } from '../../../utils/dateTimeUtils';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { EXTENDED_STATUS, progress, SETTLEMENT_KEY, UPLOAD_STATUS } from '../../constants/crmConstants';
import { ReactComponent as CloseIcon } from '../../../assets/images/svg/red_filled_cross.svg';
import { ReactComponent as FileIcon } from '../../../assets/images/svg/i_file.svg';
import { UploadFile } from 'antd/lib/upload/interface';
import { submitAdmission } from '../../../store/actions/fileAction';
import { useDispatch } from 'react-redux';
import { centeredNotification } from '../../../utils/utility';
import { FormCheckBox } from '../crmFormElement/FormInput';
import ApplicationDetail from '../../services/applicationDetail.service';
import { getFileStatus, getFileType } from '../../../utils/fileUploadUtils';
import { formatDocumentUploadedDate } from '../../../modules/crm/inPatient/service/crmUtils';

function BuddhiMedUploadListItem({ file, index, onRemove, fileListLength, selectionAllowed = false,
  onSelectToggle, newUploads, showProgress, isDocumentTypeRequired = true, disableCheckbox, form, showDate }: any): ReactElement {
  const dispatch = useDispatch();
  const rules: Rule[] = [];
  const [progress33, progress66, progress100] = progress;
  const appDetail = ApplicationDetail.instance;

  rules.push({ required: true });
  const { existingRecord, name, createdDate, status, extendedStatus, fileType = [], uid, uploadedOn } = file;

  const onDownload = (aFile: UploadFile): any => {
    const { response } = aFile;
    if (response) {
      const { errorMsg, uploadedDetails, isSuccess } = response;
      if (isSuccess) {
        const { fileGuid, fileName } = uploadedDetails[0];
        centeredNotification(`${fileName} start downloading...`, 'success');
        dispatch(submitAdmission(fileGuid));
      } else {
        centeredNotification(errorMsg);
      }
    }
  };

  let customPercent = 0;
  if (status === UPLOAD_STATUS.uploading) {
    customPercent = progress33;
  } else if (status === UPLOAD_STATUS.done) {
    customPercent = (extendedStatus === EXTENDED_STATUS.verified
      || extendedStatus === EXTENDED_STATUS.uploaded || (!extendedStatus && status === UPLOAD_STATUS.done)) ? progress100 : progress66;
  }

  return (
    <div className={`upload-list ${appDetail?.getIsPreAuthNewDesignEnabled() ? 'files-upload-list' : ''}`}>
      <Row gutter={GUTTOR_SPACE}>
        <Col md={6}>
          <div className="text-elipsis"><span className="file-count">
            {showProgress ? index + 1 : fileListLength - index}</span>
            <FileIcon className="fill-gray v-align-middle" />
            <span className="text-primary">
              <a onClick={(): void => onDownload(file)}>
                <Tooltip placement="right" title={name?.length > 16 ? name : null} mouseEnterDelay={0.8}>
                  {name}
                </Tooltip>
              </a>
            </span>
          </div>
        </Col>
        <Col md={!isDocumentTypeRequired ? 8 : 6}>
          {showDate ? formatDocumentUploadedDate(createdDate || uploadedOn) :
            createdDate || getDateWithTime(new Date())}
        </Col>
        <Col md={1} className="circular-progress">
        {<Progress type="circle" percent={customPercent} width={20}
           strokeColor={appDetail?.getIsPreAuthNewDesignEnabled() ? '#2ABF86' : undefined}/>}
        </Col>
        {
          !newUploads ? <Col md={!isDocumentTypeRequired ? 7 : 4}>
            <span className="text-primary bold fsize_sm">
              {getFileStatus(status, extendedStatus, existingRecord)}
            </span>
          </Col> : <></>
        }
        {
          isDocumentTypeRequired &&
          <Col md={newUploads ? 7 : 5}>
            {
              getFileType(fileType)
            }
          </Col>
        }
        <Col span={1}>
          {!existingRecord ? <Tooltip title="Remove"><CloseIcon data-testid={`${file.uid}-remove`} className="fill-close v-align-middle mouse-pointer"
            onClick={(): void => onRemove(uid)} /></Tooltip> : null}
          {selectionAllowed ? <FormCheckBox
            detail={{
              key: `${SETTLEMENT_KEY}${file?.uid}`,
              className: 'v-align-middle mouse-pointer',
              options: [{
                value: file?.uid, key: `${SETTLEMENT_KEY}${file?.uid}`, name: '', required: false,
                onChange: (event: any, itemIndex: any): any => onSelectToggle(uid, event, file, itemIndex),
              }],
              size: 20,
              hideLabel: true,
              checked: false,
              isEditableInDetail: true,
            }}
          /> : null}
        </Col>
      </Row>
    </div>
  );
}

export default BuddhiMedUploadListItem;
